<template>
  <div class="home">
    <div class="card horizontal" v-if="user">
      <div class="card-stacked" style="max-width: 400px; margin: 0 auto">
        <div class="card-content">
          <p>
            name: <strong>{{ user.displayName }}</strong
            ><br />email:<strong>{{ user.email }}</strong
            ><br />uid: <strong>{{ user.uid }}</strong> <br />provider:
            <strong class="teal-text">{{
              user.providerData[0].providerId
            }}</strong>
          </p>
          <li>
            <a @click="signOut">Logout</a>
          </li>
        </div>
      </div>
      <div class="sect">
        <v-btn color="red" dark class="my-3" @click="updateList">
          Update Full List
        </v-btn>
        <h1 class="section-title">MODS</h1>
        <NewModal @new-mod="newMod" />
        <div class="mods">
          <draggable
            v-model="mods"
            class="mods"
            :move="checkMove"
            @end="checkMove2"
            @change="updateListSortOrder"
          >
            <ModsAdmin
              v-for="(mod, index) in mods"
              :key="index"
              :mod="mod"
              @del-mod="delMod"
            />
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebaseui/dist/firebaseui.css";
import ModsAdmin from "@/components/ModsAdmin.vue";
import NewModal from "@/components/NewModal.vue";
import gab from "../services/gabs.js";
import draggable from "vuedraggable";

export default {
  name: "ModsEdit",
  data: () => ({
    user: null,
    mods: [],
  }),
  components: {
    ModsAdmin,
    NewModal,
    draggable,
  },
  methods: {
    updateListSortOrder({ moved }) {
      const newList = [...this.mods].map((item, index) => {
        const newSort = index + 1;
        item.hasChanged = item.sortOrder !== newSort;
        if (item.hasChanged) {
          item.sortOrder = newSort;
        }
        return item;
      });
      this.mods = newList;
    },
    checkMove: function (e) {
    },
    checkMove2: function (e) {
    },
    signOut(e) {
      e.stopPropagation();
      firebase.auth().signOut();
      this.$router.push({
        name: "Admin",
      });
    },
    newMod(mod) {
      this.mods.push(mod);
    },
    delMod(mod) {
      const index = this.mods.photos.indexOf(mod);
      if (index > -1) {
        this.mods.photos.splice(index, 1);
      }
    },
    updateList() {
    this.mods.forEach((mod) => {
      var rev = firebase.firestore().collection("mods").doc(mod.idd);
      if (rev) {
        rev.update(mod).then(() => {
          console.log("Document successfully updated!");
        });
      }
    });
  },
  },
  mounted() {
    this.mods = gab.getModsF();
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
    });
  },
  computed: {},
};
</script>

<style scoped>
.mods {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.sect {
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
